import { orpc } from "@/orpc/client";

const TIMEOUT_MS = 30_000;
const POLL_INTERVAL_MS = 2_000;

/**
 * Polls subscription status until it transitions away from "incomplete".
 * Returns true once active/trialing, or false after timeout.
 */
export async function waitForSubscriptionActive(): Promise<boolean> {
	const deadline = Date.now() + TIMEOUT_MS;

	while (Date.now() < deadline) {
		const { status } = await orpc.billing.getSubscription
			.call({})
			.catch(() => ({ status: "incomplete" as const }));

		if (status !== "incomplete" && status !== "incomplete_expired") {
			return true;
		}

		await new Promise((r) => setTimeout(r, POLL_INTERVAL_MS));
	}

	return false;
}
